// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__5GcTI","tabs":"Map_tabs__qpqRa","tab":"Map_tab__fCodM","active":"Map_active__328+Q"};